import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {AdminGuard} from './services/admin.guard';
import {AuthGuard} from './services/auth.guard';
import {NoelGuard} from './services/noel.guard';
import {TorrentAccessGuard} from './services/torrent-access.guard';
import {FeatureAccessGuard} from './services/feature-access.guard';
import {PixelGameAccessGuard} from './services/pixel-game-access.guard';
import {budgetGuard} from './budget/budget.guard';

// Chaque page est chargée au moment où elle est visitée : la page d'accueil reste ainsi légère.
const routes: Routes = [
  { path: 'budget', loadComponent: () => import('./budget/budget-page.component').then(m => m.BudgetPageComponent), canActivate: [AuthGuard, budgetGuard], canDeactivate: [(component: { canLeave: () => boolean | Promise<boolean> }) => component.canLeave()] },
  { path: 'admin/budget', loadComponent: () => import('./budget/budget-setup.component').then(m => m.BudgetSetupComponent), canActivate: [AuthGuard, AdminGuard] },
  { path:'notifications',loadComponent:()=>import('./notifications/notifications-page.component').then(module=>module.NotificationsPageComponent),canActivate:[AuthGuard] },
  {
    path: '',
    loadComponent: () => import('./home/home.component').then(module => module.HomeComponent),
  },
  {
    path: 'about',
    loadComponent: () => import('./about/about.component').then(module => module.AboutComponent),
  },
  {
    path: 'portfolio',
    loadComponent: () =>
      import('./portfolio/portfolio.component').then(module => module.PortfolioComponent),
  },
  {
    path: 'school-career',
    loadComponent: () =>
      import('./school-career/school-career.component').then(module => module.SchoolCareerComponent),
  },
  {
    path: 'contact',
    loadComponent: () => import('./contact/contact.component').then(module => module.ContactComponent),
  },
  {
    path: 'qr-generator',
    loadComponent: () =>
      import('./qr-generator/qr-generator-page.component').then(
        module => module.QrGeneratorPageComponent
      ),
    canActivate: [AuthGuard, FeatureAccessGuard],
    data: { roles: ['USER'] },
  },
  {
    path: 'pixel-game',
    loadComponent: () =>
      import('./pixel-game/pixel-game-page.component').then(module => module.PixelGamePageComponent),
    canActivate: [AuthGuard, PixelGameAccessGuard],
  },
  {
    path: 'qrcode/:code',
    loadComponent: () =>
      import('./qr-code-redirect/qr-code-redirect-page.component').then(
        module => module.QrCodeRedirectPageComponent
      ),
  },
  {
    path: 'login',
    loadComponent: () => import('./login/login.component').then(module => module.LoginComponent),
  },
  {
    path: 'forgot-password',
    loadComponent: () =>
      import('./forgot-password/forgot-password.component').then(
        module => module.ForgotPasswordComponent
      ),
  },
  {
    path: 'reset-password',
    loadComponent: () =>
      import('./reset-password/reset-password.component').then(module => module.ResetPasswordComponent),
  },
  {
    path: 'profile',
    loadComponent: () =>
      import('./profile/profile-page.component').then(module => module.ProfilePageComponent),
    canActivate: [AuthGuard],
  },
  {
    path: 'register',
    loadComponent: () =>
      import('./register/register.component').then(module => module.RegisterComponent),
  },
  {
    path: 'mes-qr-codes',
    loadComponent: () =>
      import('./my-qr-codes/my-qr-codes-page.component').then(
        module => module.MyQrCodesPageComponent
      ),
    canActivate: [AuthGuard, FeatureAccessGuard],
    data: { roles: ['USER'] },
  },
  {
    path: 'admin/users',
    loadComponent: () =>
      import('./admin-users/admin-users-page.component').then(
        module => module.AdminUsersPageComponent
      ),
    canActivate: [AuthGuard, AdminGuard],
  },
  {
    path: 'admin/media-links',
    loadComponent: () =>
      import('./admin-media-links/admin-media-links-page.component').then(
        module => module.AdminMediaLinksPageComponent
      ),
    canActivate: [AuthGuard, AdminGuard],
  },
  {
    path: 'admin/torrents',
    loadComponent: () =>
      import('./admin-torrents/admin-torrents-page.component').then(
        module => module.AdminTorrentsPageComponent
      ),
    canActivate: [AuthGuard, AdminGuard],
  },
  {
    path: 'add-torrent',
    loadComponent: () =>
      import('./torrent-add/torrent-add-page.component').then(
        module => module.TorrentAddPageComponent
      ),
    canActivate: [AuthGuard, FeatureAccessGuard],
    data: { roles: ['TORRENT_ADD'] },
  },
  {
    path: 'torrent-doc',
    loadComponent: () =>
      import('./torrent-doc/torrent-doc-page.component').then(
        module => module.TorrentDocPageComponent
      ),
    canActivate: [AuthGuard, TorrentAccessGuard],
  },
  {
    path: 'youtube-download',
    loadComponent: () =>
      import('./youtube-download/youtube-download-page.component').then(
        module => module.YoutubeDownloadPageComponent
      ),
    canActivate: [AuthGuard, FeatureAccessGuard],
    data: { roles: ['YOUTUBE_DOWNLOAD'] },
  },
  {
    path: 'media-convert',
    loadComponent: () =>
      import('./media-convert/media-convert-page.component').then(
        module => module.MediaConvertPageComponent
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'image-convert',
    loadComponent: () =>
      import('./image-convert/image-convert-page.component').then(
        module => module.ImageConvertPageComponent
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'noel',
    loadComponent: () =>
      import('./noel/noel-page.component').then(module => module.NoelPageComponent),
    canActivate: [AuthGuard, NoelGuard],
  },
  {
    path: 'legal',
    loadComponent: () =>
      import('./legal/legal-page.component').then(module => module.LegalPageComponent),
  },
  { path: 'access-denied', loadComponent: () => import('./shared/ui/route-message.component').then(m => m.RouteMessageComponent) },
  { path: '**', loadComponent: () => import('./shared/ui/route-message.component').then(m => m.RouteMessageComponent), data: { notFound: true } },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { enableViewTransitions: true,
    scrollPositionRestoration: 'enabled', anchorScrolling: 'enabled' })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
